import FileUploader from "../../../../containers/fileUpload";

const Attachments = ({ data, setData, forceRemount = false }) => {
  const onFileChange = (file) => {
    let fileData = { ...data };
    fileData.documents = file;
    setData(fileData);
  };

  return (
    <>
      {/* <FormHeader text="Attachments" /> */}
      {data && (
        <FileUploader
          accept={["pdf", "xls", "xlsx", "csv"]}
          types=".pdf, .xls, .xlsx, .csv"
          multiple
          files={data.documents}
          setFiles={onFileChange}
          forceRemount={forceRemount}
        />
      )}
    </>
  );
};

export default Attachments;
